import { render, staticRenderFns } from "./Qrcode.vue?vue&type=template&id=081fb5b8&scoped=true&"
import script from "./Qrcode.vue?vue&type=script&lang=js&"
export * from "./Qrcode.vue?vue&type=script&lang=js&"
import style0 from "./Qrcode.vue?vue&type=style&index=0&id=081fb5b8&lang=scss&scoped=true&"
import style1 from "./Qrcode.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081fb5b8",
  null
  
)

export default component.exports